import { render, staticRenderFns } from "./zhihuiwenlv.vue?vue&type=template&id=03740851&scoped=true&"
import script from "./zhihuiwenlv.vue?vue&type=script&lang=js&"
export * from "./zhihuiwenlv.vue?vue&type=script&lang=js&"
import style0 from "./zhihuiwenlv.vue?vue&type=style&index=0&id=03740851&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03740851",
  null
  
)

export default component.exports